import styled from 'styled-components';

export const Container = styled.div<LandingCardsContainerProps>`
    box-shadow: 0 4px 24px 0 #00000026;
    transform: translateX(${({ $offset = 0 }) => $offset * 78}px);
    transition: transform 1s cubic-bezier(0.68, -0.6, 0.32, 1.6);
`;
